// DataTables initialization utility
// DataTables is loaded from public folder via script tags in index.html
// This utility re-exports jQuery from the jquery utility

import $ from './jquery';

// DataTables and responsive plugin are loaded via script tags in index.html
// They will be available on $.fn.dataTable
if (typeof window !== 'undefined' && typeof window.DataTable === 'undefined' && $.fn.dataTable) {
    window.DataTable = $.fn.dataTable;
    window.DataTables = $.fn.dataTable;
}

// Export jQuery with DataTables attached
export default $;
